// extracted by mini-css-extract-plugin
export default {"centered":"TableValuesBody_centered__xPBGF","message":"TableValuesBody_message__EbhXd"};